//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable*/
import _ from 'underscore'

export default {
  props: {
    latitude: {
      default: ''
    },
    longitude: {
      default: ''
    },
    value: {
      default: ''
    }
  },
  data: function () {
    return {
      form: {
        region: '成都',
        coordinate: (this.latitude && this.longitude) ? `${this.latitude},${this.longitude}` : '',
        currentLongitude: this.longitude,
        currentLatitude: this.latitude,
        currentAddress: this.value,
        currentValue: this.value
      }
    }
  },
  watch: {
    value: {
      handler (val) {
        if (this.form.currentAddress !== val && _.isEmpty(this.form.currentAddress)) {
          this.form.currentAddress = val
        }
        if (this.form.currentValue !== val) {
          this.form.currentValue = val
        }
      },
      immediate: true
    },
    'form.currentValue': {
      handler (val) {
        if (val !== undefined && this.value !== val) {
          this.$emit('input', val)
        }
      },
      immediate: true
    },
    latitude: {
      handler (val) {
        if (_.isEmpty(this.form.coordinate) && this.latitude && this.longitude) {
          this.form.coordinate = `${this.latitude},${this.longitude}`
        }
        if (val && val !== this.form.currentLatitude) {
          this.form.currentLatitude = val
          this.initCoordinate()
        }
      },
      immediate: true
    },
    longitude: {
      handler (val) {
        if (_.isEmpty(this.form.coordinate) && this.latitude && this.longitude) {
          this.form.coordinate = `${this.latitude},${this.longitude}`
        }
        if (val && val !== this.form.currentLongitude) {
          this.form.currentLongitude = val
          this.initCoordinate()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.initMap()
  },
  methods: {
    setCoordinate (latLng) {
      let lat = latLng.getLat().toFixed(6)
      let lng = latLng.getLng().toFixed(6)
      let v = `${lat},${lng}`
      this.form.coordinate = v
      this.$emit('update:latitude', lat)
      this.$emit('update:longitude', lng)
    },
    setAddr (address) {
      this.form.currentAddress = address
      this.$emit('input', address)
    },
    initCoordinate (){
      if (!_.isEmpty(this.form.currentLatitude) && !_.isEmpty(this.form.currentLongitude)) {
        function setMarker(o){
          let latlng = new qq.maps.LatLng(o.lat, o.lng)
          let latlngBounds = new qq.maps.LatLngBounds()
          latlngBounds.extend(latlng)
          //let left = n * 27;
          let marker = new qq.maps.Marker({
            map: map,
            position: latlng,
            zIndex: 10
          })
          marker.index = o.index
          marker.isClicked = false
          setAnchor(marker, true)
        }
        function setAnchor(marker, flag) {
          let left = marker.index * 27
          if (flag === true) {
            let anchor = new qq.maps.Point(10, 30)
            let origin = new qq.maps.Point(left, 0)
            let size = new qq.maps.Size(27, 33)
            let icon = new qq.maps.MarkerImage('http://lbs.qq.com/tool/getpoint/img/marker10.png', size, origin, anchor)
            marker.setIcon(icon)
          } else {
            let anchor = new qq.maps.Point(10, 30)
            let origin = new qq.maps.Point(left, 35)
            let size = new qq.maps.Size(27, 33)
            let icon = new qq.maps.MarkerImage('http://lbs.qq.com/tool/getpoint/img/marker10.png', size, origin, anchor)
            marker.setIcon(icon)
          }
        }
        let _this = this
        let map = new qq.maps.Map(container, {
          zoom: 10
        })
        map.panTo(new qq.maps.LatLng(this.form.currentLatitude, this.form.currentLongitude));
        map.zoomTo(17);
        let coord=new qq.maps.LatLng(this.form.currentLatitude, this.form.currentLongitude);
        let geocoder = new qq.maps.Geocoder({
          complete: (result) => {
            if (_.isEmpty(this.form.currentAddress)) {
              _this.setAddr(result.detail.address)
            }
          }
        })
        geocoder.getAddress(coord)
        setMarker({lat: this.form.currentLatitude, lng: this.form.currentLongitude, index:0})
      }
    },
    initMap () {
      let container = document.getElementById('container')
      let map = new qq.maps.Map(container, {
        zoom: 10
      })
      let markerArray = []
      let btnSearch = document.getElementById('btn_search')
      let bside = document.getElementById('bside_left')
      let search = document.getElementById('search_t')
      let curCity = document.getElementById('curCity')
      let _this = this
      let label = new qq.maps.Label({
        map: map,
        offset: new qq.maps.Size(15, -12),
        draggable: false,
        clickable: false
      })
      let cityservice = new qq.maps.CityService({
        complete: function(result) {
          //curCity.children[0].innerHTML = result.detail.name;
          map.setCenter(result.detail.latLng);
        }
      })
      let key = '4XVBZ-7PV6V-7L3PF-UTF4F-AP55Q-PIFLH'
      if( !_.isEmpty(this.form.currentLongitude) && !_.isEmpty(this.form.currentLatitude) ){
        map.panTo(new qq.maps.LatLng(this.form.currentLatitude, this.form.currentLongitude));
        map.zoomTo(17);
        let coord=new qq.maps.LatLng(this.form.currentLatitude, this.form.currentLongitude);
        let geocoder = new qq.maps.Geocoder({
          complete: function(result){
            _this.setAddr(result.detail.address)
          }
        })
        geocoder.getAddress(coord)
        setMarker({lat: this.form.currentLatitude, lng: this.form.currentLongitude, index:0})
      }else{
        cityservice.searchLocalCity()
      }
      map.setOptions({
        draggableCursor: 'crosshair'
      })
      function setMarker(o){
        let latlng = new qq.maps.LatLng(o.lat, o.lng)
        let latlngBounds = new qq.maps.LatLngBounds()
        latlngBounds.extend(latlng)
        //let left = n * 27;
        let marker = new qq.maps.Marker({
          map: map,
          position: latlng,
          zIndex: 10
        })
        marker.index = o.index
        marker.isClicked = false
        setAnchor(marker, true)
      }
      function setAnchor(marker, flag) {
        let left = marker.index * 27
        if (flag === true) {
          let anchor = new qq.maps.Point(10, 30)
          let origin = new qq.maps.Point(left, 0)
          let size = new qq.maps.Size(27, 33)
          let icon = new qq.maps.MarkerImage('http://lbs.qq.com/tool/getpoint/img/marker10.png', size, origin, anchor)
          marker.setIcon(icon)
        } else {
          let anchor = new qq.maps.Point(10, 30)
          let origin = new qq.maps.Point(left, 35)
          let size = new qq.maps.Size(27, 33)
          let icon = new qq.maps.MarkerImage('http://lbs.qq.com/tool/getpoint/img/marker10.png', size, origin, anchor)
          marker.setIcon(icon)
        }
      }
      function setCurrent(arr, index, isMarker) {
          if (isMarker) {
            each(markerArray, function (n, ele) {
              if (n === index) {
                setAnchor(ele, false)
                ele.setZIndex(10)
              } else {
                if (!ele.isClicked) {
                  setAnchor(ele, true)
                  ele.setZIndex(9)
                }
              }
            })
          } else {
            each(markerArray, function (n, ele) {
              if (n === index) {
                ele.div.style.background = '#DBE4F2'
              } else {
                if (!ele.div.isClicked) {
                  ele.div.style.background = '#fff'
                }
              }
            })
          }
      }
      function setFlagClicked(arr, index) {
        each(markerArray, function (n, ele) {
          if (n === index) {
            ele.isClicked = true
            ele.div.isClicked = true
            let str = `<div style="width:250px;">${ele.div.children[1].innerHTML.toString()}</div>`
            let latLng = ele.getPosition()
            _this.setCoordinate(latLng)
          } else {
            ele.isClicked = false
            ele.div.isClicked = false
          }
        })
      }
      function each (obj, fn) {
        for (let n = 0, l = obj.length; n < l; n++) {
          fn.call(obj[n], n, obj[n])
        }
      }
      $(container).mouseenter(function () {
        label.setMap(map)
      })
      $(container).mouseleave(function () {
        label.setMap(null)
      })
      qq.maps.event.addListener(map, 'mousemove', function (e) {
        let latlng = e.latLng
        label.setPosition(latlng)
        label.setContent(`${latlng.getLat().toFixed(6)},${latlng.getLng().toFixed(6)}`)
      })
      let url3
      qq.maps.event.addListener(map, 'click', function (e) {
        _this.setCoordinate(e.latLng)
        url3 = encodeURI(`http://apis.map.qq.com/ws/geocoder/v1/?location=${e.latLng.getLat()},${e.latLng.getLng()}&key=${key}&output=jsonp&&callback=?`)
        $.getJSON(url3, function (result) {
          if (result.result !== undefined) {
            _this.setAddr(result.result.address)
          } else {
            _this.setAddr('')
          }
        })
      })
      qq.maps.event.addListener(map, 'zoom_changed', function () {
        document.getElementById('level').innerHTML = `当前缩放等级：${map.getZoom()}`
      })
      let listener_arr = []
      let isNoValue = false
      qq.maps.event.addDomListener(btnSearch, 'click', function () {
        let value = search.value
        let latlngBounds = new qq.maps.LatLngBounds()
        for (let i = 0, l = listener_arr.length; i < l; i++) {
          qq.maps.event.removeListener(listener_arr[i])
        }
        listener_arr.length = 0
        let queryCity = curCity.value
        // console.log('queryCity', queryCity)
        let url = encodeURI(`http://apis.map.qq.com/ws/place/v1/search?keyword=${value}&boundary=region(${queryCity},0)&page_size=9&page_index=1&key=${key}&output=jsonp&&callback=?`)
        // console.log('url', url)
        $.getJSON(url, function (result) {
          // console.log('ws/place/v1/search.result', result)
          if (result.count) {
            isNoValue = false
            bside.innerHTML = ''
            each(markerArray, function (n, ele) {
              ele.setMap(null)
            })
            markerArray.length = 0
            each(result.data, function (n, ele) {
              let latlng = new qq.maps.LatLng(ele.location.lat, ele.location.lng)
              latlngBounds.extend(latlng)
              let left = n * 27
              let marker = new qq.maps.Marker({
                map: map,
                position: latlng,
                zIndex: 10
              })
              marker.index = n
              marker.isClicked = false
              setAnchor(marker, true)
              markerArray.push(marker)
              let listener1 = qq.maps.event.addDomListener(marker, 'mouseover', function () {
                let n = this.index
                setCurrent(markerArray, n, false)
                setCurrent(markerArray, n, true)
                label.setContent(`${this.position.getLat().toFixed(6)},${this.position.getLng().toFixed(6)}`)
                label.setPosition(this.position)
                label.setOptions({
                  offset: new qq.maps.Size(15, -20)
                })
              })
              listener_arr.push(listener1)
              let listener2 = qq.maps.event.addDomListener(marker, 'mouseout', function () {
                let n = this.index
                setCurrent(markerArray, n, false)
                setCurrent(markerArray, n, true)
                label.setOptions({
                  offset: new qq.maps.Size(15, -12)
                })
              })
              listener_arr.push(listener2)
              let listener3 = qq.maps.event.addDomListener(marker, 'click', function () {
                let n = this.index
                setFlagClicked(markerArray, n)
                setCurrent(markerArray, n, false)
                setCurrent(markerArray, n, true)
                _this.setAddr(bside.childNodes[n].childNodes[1].childNodes[1].innerHTML.substring(3))
              })
              listener_arr.push(listener3)
              map.fitBounds(latlngBounds)
              let div = document.createElement('div')
              div.className = 'info_list text-sm'
              div.style.cssText = 'font-size:14px;line-height:20px;padding:5px;cursor: pointer;'
              let order = document.createElement('div')
              let leftn = -54 - 17 * n
              order.style.cssText = `width:17px;height:17px;margin:3px 3px 0px 0px;float:left;background:url(http://lbs.qq.com/tool/getpoint/img/marker_n.png) ${leftn}px 0px`
              div.appendChild(order)
              let pannel = document.createElement('div')
              pannel.style.cssText = 'width:175px;float:left;'
              div.appendChild(pannel)
              let name = document.createElement('p')
              name.style.cssText = 'margin:0px;color:#0000CC'
              name.innerHTML = ele.title
              pannel.appendChild(name)
              let address = document.createElement('p')
              address.style.cssText = 'margin:0px;'
              address.innerHTML = `地址：${ele.address}`
              pannel.appendChild(address)
              if (ele.tel !== undefined) {
                let phone = document.createElement('p')
                phone.style.cssText = 'margin:0px;'
                phone.innerHTML = `电话：${ele.tel}`
                pannel.appendChild(phone)
              }
              let position = document.createElement('p')
              position.style.cssText = 'margin:0px;'
              position.innerHTML = `坐标：${ele.location.lat.toFixed(6)}，${ele.location.lng.toFixed(6)}`
              pannel.appendChild(position)
              bside.appendChild(div)
              div.style.height = `${pannel.offsetHeight+5}px`
              div.isClicked = false
              div.index = n
              marker.div = div
              div.marker = marker
            })
            $('#bside_left').delegate('.info_list', 'mouseover', function (e) {
              var n = this.index
              setCurrent(markerArray, n, false)
              setCurrent(markerArray, n, true)
            })
            $('#bside_left').delegate('.info_list', 'mouseout', function () {
              each(markerArray, function (n, ele) {
                if (!ele.isClicked) {
                  setAnchor(ele, true)
                  ele.div.style.background = '#fff'
                }
              })
            })
            $('#bside_left').delegate('.info_list', 'click', function (e) {
              let n = this.index
              setFlagClicked(markerArray, n)
              setCurrent(markerArray, n, false)
              setCurrent(markerArray, n, true)
              map.setCenter(markerArray[n].position)
              _this.setAddr(this.childNodes[1].childNodes[1].innerHTML.substring(3))
            })
          } else {
            bside.innerHTML = ''
            each(markerArray, function (n, ele) {
              ele.setMap(null)
            })
            markerArray.length = 0
            var novalue = document.createElement('div')
            novalue.id = 'no_value'
            novalue.innerHTML = '对不起，没有搜索到您要找的结果!'
            bside.appendChild(novalue)
            isNoValue = true
          }
        })
      })
      btnSearch.onmousedown = function () {
        // this.className = 'btn btn-default active'
      }
      btnSearch.onmouseup = function () {
        // this.className = 'btn btn-default'
      }
      $('#search_t').autocomplete({
        source: function (request, response) {
          let url4 = encodeURI(`http://apis.map.qq.com/ws/place/v1/suggestion/?keyword=${request.term}&region=${this.region}&key=4XVBZ-7PV6V-7L3PF-UTF4F-AP55Q-PIFLH&output=jsonp&&callback=?`)
          $.getJSON(url4, function (result) {
            // console.log('apis.map.qq.com/ws/place/v1/suggestion.result', result)
            response($.map(result.data, function (item) {
              return ({
                label: item.title
              })
            }))
          })
        }
      })
    }
  }
}
